import React, { useMemo } from "react";
import PropTypes from "prop-types";
import RtiCard from "./RtiCard";
import { ASSET_QUERY, ASSET_CATEGORY_QUERY } from "features/insuranceDocument/edit/general/asset/queries";
import { FINANCING_TYPES_QUERY } from "features/insuranceDocument/queries/insuranceDocumentQueries";
import { CURRENCY_QUERY } from "features/insuranceDocument/queries/insuranceDocumentQueries";
import { useState } from "react";
import { useDictionaryHandling, useQueryWithSimpleErrorHandling } from "hooks";

const RtiContainer = ({ insuranceData, loading }) => {
  const [assetData, setAssetData] = useState({
    currentMileage: "",
    manufacturingYear: "",
    purchasePrice: "",
    assetCategoryName: ""
  });

  const { loading: assetLoading } = useQueryWithSimpleErrorHandling(ASSET_QUERY, {
    variables: { assetId: insuranceData.assetId },
    skip: !insuranceData?.assetId,
    onCompleted: data => {
      setAssetData(data?.asset);
    },
    notifyOnNetworkStatusChange: true
  });

  const { data: financingTypesData } = useQueryWithSimpleErrorHandling(FINANCING_TYPES_QUERY);

  useQueryWithSimpleErrorHandling(ASSET_CATEGORY_QUERY, {
    skip: !assetData.cascoCategoryId,
    variables: { id: assetData.cascoCategoryId },
    onCompleted: data => {
      setAssetData({ ...assetData, assetCategoryName: data.assetCategory.name });
    }
  });
  const { getCodeById } = useDictionaryHandling(CURRENCY_QUERY, "currencies");
  const currencyCode = useMemo(() => getCodeById(insuranceData.currencyId), [getCodeById, insuranceData.currencyId]);

  const data = useMemo(() => {
    return {
      financingDocumentNumber: insuranceData.financingDocumentNumber || "",
      financingType: insuranceData.financingType,
      assetType: assetData.assetCategoryName,
      manufacturingYear: assetData.manufacturingYear,
      currentMileage: assetData.currentMileage,
      purchasePrice: assetData.purchasePrice,
      period: insuranceData.period || "",
      currencyCode: currencyCode || ""
    };
  }, [insuranceData, assetData, currencyCode]);

  return (
    <RtiCard
      data={data}
      financingTypes={financingTypesData?.financingTypes}
      insuranceDataLoading={loading}
      assetDataLoading={assetLoading}
    />
  );
};

RtiContainer.propTypes = {
  insuranceData: PropTypes.object,
  loading: PropTypes.bool.isRequired
};

export default RtiContainer;
